import {Controller} from "@hotwired/stimulus"
import getCookie from "~/utilities/get-cookie"

export default class extends Controller {
  connect() {
    let currentTheme = getCookie("theme")

    if (!currentTheme) {
      currentTheme = "dark"
      document.cookie = `theme=${currentTheme}; path=/; max-age=31536000`
    }

    document.documentElement.dataset.theme = currentTheme
  }

  toggle() {
    let currentTheme = getCookie("theme")

    currentTheme = currentTheme === "dark" ? "light" : "dark"
    document.cookie = `theme=${currentTheme}; path=/; max-age=31536000`

    document.documentElement.dataset.theme = currentTheme
  }
}
